export const Position = {
  "June 2024 - Present": {
    company: "Hackazouk Inc.",
    link: "https://www.hackazouk.com/",
    positions: [
      {
        position: "Full Stack Developer",
        description: [
          "Modernized a client’s CodeIgniter 3 app by migrating to Laravel, improving functionality, design, and performance.",
          "Developed full-stack, responsive, and efficient web applications for different clients of the consulting team.",
        ],
      },
    ],
    technologies: [
      "Laravel",
      "PHP",
      "Bootstrap",
      "AJAX",
      "jQuery",
      "SASS / SCSS",
    ],
  },
  "June 2023 - May 2024": {
    company: "The Guidon",
    link: "https://theguidon.com/",
    positions: [
      {
        position: "Digital Development Staff",
        description: [
          "Enhanced the mobile responsiveness of The Guidon Archives during the development process using Tailwind and React",
          "Developed The Guidon UAAP Season 86 Primer using HTML, CSS, and JavaScript",
        ],
      },
    ],
    technologies: ["Tailwind", "React", "HTML", "CSS", "JavaScript"],
  },
  "Jun - Aug 2022\nJun - Aug 2023 ": {
    company: "Ateneo Orientation Seminar",
    link: "https://www.facebook.com/2022OrSem/",
    positions: [
      {
        position: "Web Head • Web Deputy",
        description: [
          "Leveraged Figma, Django REST, React, and custom scripts to optimize ADMU's freshman website, enhancing design, content management, and performance for 1,500+ users.",
        ],
      },
    ],
    technologies: ["Django REST", "React", "TailwindCSS", "SCSS/SASS"],
  },
  "June 2022 - May 2023": {
    company: "Computer Society of the Ateneo",
    link: "https://compsat.org/",
    positions: [
      {
        position: "Vice President for Development and Training",
        description: [
          "Project-managed and developed Celebrate Your Sparkle website and Fearless company website",
          "Successfully managed and organized training workshops for more than 100 Dev team members",
          "Developed an enlistment website where 1,800+ seniors can sign up for their photoshoot schedules",
        ],
      },
    ],
    technologies: ["Django REST", "PostgreSQL", "React", "NextJS"],
  },
  "June 2021 - May 2023": {
    company: "Google Developer Student Clubs - Loyola",
    link: "https://www.facebook.com/gdscloyola/",
    positions: [
      {
        position: "Engineering Lead • Senior Software Engineer",
        description: [
          "Conducted a workshop on Introduction to Python during Study Jams 2023",
          "Led the development team and developed the features for adding classes and tasks in the Beadle App, a mobile enlistment assistant application, using Flutter",
        ],
      },
    ],
    technologies: ["Flutter"],
  },
};
